// Simple word replacement for thought reframing
const extremeWordMap = {
  always: 'sometimes',
  never: 'not always',
  everyone: 'some people',
  nobody: 'not everyone',
  "can't": 'can try',
  impossible: 'challenging',
  terrible: 'difficult',
  awful: 'uncomfortable',
  disaster: 'setback',
  ruined: 'affected',
  stupid: 'learning',
  worthless: 'struggling',
  hate: 'dislike',
  worst: 'difficult',
};

export function reframeThought(thought, exerciseType) {
  if (!thought.trim()) {
    return null;
  }

  // Replace extreme words with balanced alternatives
  let reframed = thought.toLowerCase();
  
  Object.entries(extremeWordMap).forEach(([extreme, balanced]) => {
    const regex = new RegExp(`\\b${extreme}\\b`, 'gi');
    reframed = reframed.replace(regex, balanced);
  });

  // Capitalize first letter
  reframed = reframed.charAt(0).toUpperCase() + reframed.slice(1);

  // Add balanced framing prefix
  const framingPhrases = [
    'A more balanced way to see this might be:',
    'Another perspective could be:',
    'A kinder way to think about this:',
    'A more realistic view might be:',
  ];

  const randomPhrase = framingPhrases[Math.floor(Math.random() * framingPhrases.length)];

  // Get action suggestion based on exercise type
  const actionSuggestion = getActionSuggestion(exerciseType);

  return {
    original: thought,
    reframed: `${randomPhrase} ${reframed}`,
    action: actionSuggestion,
  };
}

function getActionSuggestion(exerciseType) {
  const suggestions = {
    thought_reframing: '💡 Action: Write down one thing you did well today, no matter how small.',
    stress_reset: '💡 Action: Take 5 slow breaths and notice 3 things you can see around you.',
    overwhelm: '💡 Action: Pick ONE task and do it for 10 minutes. That\'s enough for now.',
    anxiety: '💡 Action: Name one thing you\'ve worried about that didn\'t happen.',
    compassion: '💡 Action: Place your hand on your heart and say: "I deserve kindness."',
  };

  return suggestions[exerciseType] || '💡 Action: Take a moment to breathe and be kind to yourself.';
}
